// we exclude these keys because we want these filter keys to persist when we clear filters
export const filterKeysToExclude = new Set([
  'brandName',
  'browseKey',
  'browseValue',
  'colorValue',
  'designerValue',
  'pageSlug',
  'productSlug',
  'query',
  'silhouette',
  'slug',
  'subCategory',
  'technologyValue',
  'timelineYear',
  'upperMaterialValue',
]);
